import { action, computed, makeObservable, observable } from 'mobx';
import { Step, StepName } from '../config/Wizard';
import RegistrationAuthenticateStep from '../components/registration/authenticate/RegistrationAuthenticateStep';
import RegistrationSelectTrainingStep from '../components/registration/select-items/RegistrationSelectSellingItemsStep';
import RegistrationSuccessStep from '../components/registration/RegistrationSuccessStep';
import RegistrationFailedStep from '../components/registration/RegistrationFailedStep';
import RegistrationHistoryStep from '../components/registration/RegistrationHistoryStep';
import RegistrationPartialSuccessStep from 'src/components/registration/RegistrationPartialSuccessStep';
import EventPhotosView from 'src/components/EventPhotosView';
import OTPStep from 'src/components/registration/authenticate/OTPStep';
import MyProgressStep from 'src/components/registration/MyProgressStep';
import LeaderboardStep from 'src/components/registration/LeaderboardStep';
import CampaignsView from 'src/components/CampaignsView';
import { AuthStore } from './AuthStore';
import { getPhoneNumberFromToken } from 'src/util';

export default class WizardStore {
  @observable public steps: Map<StepName, Step> = new Map();
  @observable public currentStepName: StepName = null;
  public authStore: AuthStore;
  public registrationStore: any;

  constructor() {
    makeObservable(this);
    this.authStore = new AuthStore();
    this.initializeSteps();
  }

  @computed
  get currentStep(): Step {
    const currentStepName: StepName = Array.from(this.stepKeys).find((stepName: StepName) => this.currentStepName === stepName);
    return this.steps.get(currentStepName);
  }

  @computed
  get stepKeys(): StepName[] {
    return Array.from(this.steps.keys());
  }

  @action
  public initializeSteps = () => {
    this.steps.set(StepName.REGISTRATION_AUTHENTICATE, {
      state: 'current',
      component: RegistrationAuthenticateStep
    });
    this.steps.set(StepName.REGISTRATION_AUTHENTICATE_OTP, {
      state: '',
      component: OTPStep
    });
    this.steps.set(StepName.REGISTRATION_SELECT_TRAINING, {
      state: '',
      component: RegistrationSelectTrainingStep
    });
    this.steps.set(StepName.REGISTRATION_SUCCESS, {
      state: '',
      component: RegistrationSuccessStep
    });
    this.steps.set(StepName.REGISTRATION_FAILED, {
      state: '',
      component: RegistrationFailedStep
    });
    this.steps.set(StepName.REGISTRATION_PARTIAL_SUCCESS, {
      state: '',
      component: RegistrationPartialSuccessStep
    });
    this.steps.set(StepName.REGISTRATION_HISTORY, {
      state: '',
      component: RegistrationHistoryStep
    });
    this.steps.set(StepName.EVENTS_VIEW, {
      state: '',
      component: EventPhotosView,
    });
    this.steps.set(StepName.WHATS_NEW, {
      state: '',
      component: CampaignsView
    });
    this.steps.set(StepName.MY_PROGRESS, {
      state: '',
      component: MyProgressStep
    });
    this.steps.set(StepName.LEADERBOARD, {
      state: '',
      component: LeaderboardStep
    });

    // Set initial step - we'll load user data after all stores are initialized
    this.currentStepName = StepName.REGISTRATION_AUTHENTICATE;
  }

  @action
  public setStep = (step: StepName) => {
    // Check token types before changing step
    this.authStore.checkTokenType();
    this.currentStepName = step;
  }

  @action
  public checkInitialAuth = () => {
    if (this.authStore.isUserFlow && this.registrationStore) {
      const phoneNumber = getPhoneNumberFromToken();
      if (phoneNumber) {
        this.registrationStore.loadUser(phoneNumber);
      }
    }
  }
}
